import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AqsnPropertyDetailsService } from 'src/app/services/aqsn-property-details.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { Utils } from 'src/app/shared/utils';
import { FileUploadSourceType } from 'src/app/shared/enum-value';
import { LaunchDarklyUtil } from 'src/app/shared/launch-darkly-util';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

@Component({
  standalone: false,
  selector: 'app-acquisition-property-details',
  templateUrl: './acquisition-property-details.component.html',
  styleUrl: './acquisition-property-details.component.css'
})
export class AcquisitionPropertyDetailsComponent {

  @Input() disableUpload: boolean = false;
  @Output() closeSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() propertyFileUploadDetailsFromSidebar: EventEmitter<object> = new EventEmitter<object>();

  propertyData: any = [];
  fileUploadData: any = [];
  cols: any[];
  data: any[] = [];
  systemDownFlagValue: boolean = false;

  constructor(private aqsnPropertyDetailsService: AqsnPropertyDetailsService,
    private router: Router,
    private apiService: ApiService,
    private utils: Utils,
    private fileUploadService: FileUploadService,
    private launchDarkly: LaunchDarklyUtil) {
  }

  ngOnInit() {
    this.aqsnPropertyDetailsService.AqsnPropertyDetailsServiceSub.subscribe((_propertyDetails: any) => {
      this.propertyData = ({
        propNme: _propertyDetails.propNme,
        complianceRate: _propertyDetails.complianceRate,
        coltRefNo: _propertyDetails.coltRefNo,
        dlNme: _propertyDetails.dlNme,
        dusDealId: _propertyDetails.dusDealId,
        aqsnDealId: _propertyDetails.aqsnDealId,
        aqsnDt: this.utils.getFormattedDate(_propertyDetails.aqsnDt),
        maxSubmtDt: this.utils.getFormattedDate(_propertyDetails.maxSubmtDt),
        pca: _propertyDetails.pca,
        esa: _propertyDetails.esa,
        zon: _propertyDetails.zon,
        sra: _propertyDetails.sra,
        appr: _propertyDetails.appr,
        reqdSubmDt: this.utils.getFormattedDate(_propertyDetails.reqdSubmtDt),
        pcaFilename: this.convertFilenameToShortName(_propertyDetails.filenamePCA),
        esaFilename: this.convertFilenameToShortName(_propertyDetails.filenameESA),
        zonFilename: this.convertFilenameToShortName(_propertyDetails.filenameZON),
        sraFilename: this.convertFilenameToShortName(_propertyDetails.filenameSRA),
        apprFilename: this.convertFilenameToShortName(_propertyDetails.filenameAPPR),
        pcaSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.fileRcvdDttmPCA),
        esaSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.fileRcvdDttmESA),
        zonSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.fileRcvdDttmZON),
        sraSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.fileRcvdDttmSRA),
        apprSubmittedOn: this.utils.getFormattedDateWithHhMmSs(_propertyDetails.fileRcvdDttmAPPR),
        propMstrNo: _propertyDetails.propMstrNo,
        transType: _propertyDetails.transType,
        ssn: _propertyDetails.ssn,
        propId: _propertyDetails.propId,
        cmmtNo: _propertyDetails.cmmtNo,
      });


      
      this.launchDarkly.launchDarklySub.subscribe((systemDownFlagValue) => {
        this.systemDownFlagValue = systemDownFlagValue;
      });

      this.loadTable();
    });


    this.cols = [
      { field: 'docType', header: 'Document Type', width: '125px' },
      { field: 'fileName', header: 'File Name', width: '125px' },
      { field: 'submittedOn', header: 'Submitted On', width: '125px' }
    ];
  }

  loadTable() {
    this.data = [];

    if (this.propertyData.appr && this.propertyData.appr.trim().length > 0) {
      this.data.push({ "docType": 'APPR_' + this.propertyData.appr + '_', fileName: this.propertyData.apprFilename, 'submittedOn': this.propertyData.apprSubmittedOn });
    }

    if (!this.propertyData.appr) {
      this.data.push({ "docType": 'APPR_' + 'null_', fileName: this.propertyData.apprFilename, 'submittedOn': this.propertyData.apprSubmittedOn });
    }

    if (this.propertyData.esa && this.propertyData.esa.trim().length > 0) {
      this.data.push({ "docType": 'ESA_' + this.propertyData.esa + '_', fileName: this.propertyData.esaFilename, 'submittedOn': this.propertyData.esaSubmittedOn });
    }

    if (!this.propertyData.esa) {
      this.data.push({ "docType": 'ESA_' + 'null_', fileName: this.propertyData.esaFilename, 'submittedOn': this.propertyData.esaSubmittedOn });
    }

    if (this.propertyData.pca && this.propertyData.pca.trim().length > 0) {
      this.data.push({ "docType": 'PCA_' + this.propertyData.pca + '_', fileName: this.propertyData.pcaFilename, 'submittedOn': this.propertyData.pcaSubmittedOn });
    }

    if (!this.propertyData.pca) {
      this.data.push({ "docType": 'PCA_' + 'null_', fileName: this.propertyData.pcaFilename, 'submittedOn': this.propertyData.pcaSubmittedOn });
    }

    if (this.propertyData.sra && this.propertyData.sra.trim().length > 0) {
      this.data.push({ "docType": 'SRA_' + this.propertyData.sra + '_', fileName: this.propertyData.sraFilename, 'submittedOn': this.propertyData.sraSubmittedOn });
    }

    if (!this.propertyData.sra) {
      this.data.push({ "docType": 'SRA_' + 'null_', fileName: this.propertyData.sraFilename, 'submittedOn': this.propertyData.sraSubmittedOn });
    }

    if (this.propertyData.zon && this.propertyData.zon.trim().length > 0) {
      this.data.push({ "docType": 'ZON_' + this.propertyData.zon + '_', fileName: this.propertyData.zonFilename, 'submittedOn': this.propertyData.zonSubmittedOn });
    }

    if (!this.propertyData.zon) {
      this.data.push({ "docType": 'ZON_' + 'null_', fileName: this.propertyData.zonFilename, 'submittedOn': this.propertyData.zonSubmittedOn });
    }

    this.launchDarkly.getLaunchDarklyShutDown(null, null)
  }

  showUploadFilesDialog(flag: boolean) {
      if (this.systemDownFlagValue) {
        this.apiService.shutDownApp = true;
        this.router.navigate([''], { skipLocationChange: true });
        return;
      }

      let selectedPropertyName = this.propertyData.propNme;
      let selectedDusDealId = this.propertyData.dusDealId;
      let selectedColtRefNo = this.propertyData.coltRefNo;
      let selectedAqsnDealId = this.propertyData.aqsnDealId;
      let selectedPropMstrNo = this.propertyData.propMstrNo;
      let selectedTransType = this.propertyData.transType;
      let selectedSSN = this.propertyData.ssn;
      let selectedPropId = this.propertyData.propId;
      let selectedCmmtNo = this.propertyData.cmmtNo;
      let showUploadFiles = flag;
      this.propertyFileUploadDetailsFromSidebar.emit({ selectedPropertyName, selectedDusDealId, selectedColtRefNo, selectedAqsnDealId, selectedPropMstrNo, selectedTransType, selectedSSN, selectedPropId, selectedCmmtNo, showUploadFiles });
      this.fileUploadService.setSource(FileUploadSourceType.AcquisitionPropertyDetails);
   }

  onClickCloseSidebar() {
    this.closeSidebar.emit(true);
  }

  // Convert "73a80411-5ae0-4a6d-8f6b-c42f99a4c35c___179053_ZON_Valid_CITI_DUSG_WithCRN.xml" to "179053_ZON_Valid_CITI_DUSG_WithCRN.xml"
  convertFilenameToShortName(filename: string) {
    if (filename) {
      let splitFilename = filename.split('___');
      if (splitFilename.length > 1) {
        return splitFilename[1];
      }
    }
    return filename;
  }
}
